// Transforms Style Plugin
export default {
    id: 'transforms',
    label: 'Transforms',
    icon: 'RotateCw',
    properties: {
        backfaceVisibility: {
            label: 'Backface Visibility',
            type: 'select',
            options: ['visible', 'hidden'],
            default: 'visible',
            toClass: (value) => value ? `backface-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^backface-(.+)$/);
                return match ? match[1] : null;
            }
        },
        perspective: {
            label: 'Perspective',
            type: 'select',
            options: ['none', 'sm', 'md', 'lg', 'xl', '2xl'],
            default: 'none',
            toClass: (value) => value ? `perspective-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^perspective-(.+)$/);
                return match ? match[1] : null;
            }
        },
        perspectiveOrigin: {
            label: 'Perspective Origin',
            type: 'select',
            options: ['center', 'top', 'top-right', 'right', 'bottom-right', 'bottom', 'bottom-left', 'left', 'top-left'],
            default: 'center',
            toClass: (value) => value ? `perspective-origin-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^perspective-origin-(.+)$/);
                return match ? match[1] : null;
            }
        },
        rotate: {
            label: 'Rotate',
            type: 'select',
            options: ['0', '1', '2', '3', '6', '12', '45', '90', '180'],
            default: '0',
            toClass: (value) => value ? `rotate-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^rotate-(.+)$/);
                return match ? match[1] : null;
            }
        },
        scale: {
            label: 'Scale',
            type: 'select',
            options: ['0', '50', '75', '90', '95', '100', '105', '110', '125', '150'],
            default: '100',
            toClass: (value) => value ? `scale-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^scale-(.+)$/);
                return match ? match[1] : null;
            }
        },
        skew: {
            label: 'Skew',
            type: 'select',
            options: ['0', '1', '2', '3', '6', '12'],
            default: '0',
            toClass: (value) => value ? `skew-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^skew-(.+)$/);
                return match ? match[1] : null;
            }
        },
        transform: {
            label: 'Transform',
            type: 'select',
            options: ['transform', 'transform-none', 'transform-gpu', 'transform-cpu'],
            default: 'transform',
            toClass: (value) => value || null,
            fromClass: (className) => {
                const options = ['transform', 'transform-none', 'transform-gpu', 'transform-cpu'];
                return options.includes(className) ? className : null;
            }
        },
        transformOrigin: {
            label: 'Origin',
            type: 'select',
            options: ['center', 'top', 'top-right', 'right', 'bottom-right', 'bottom', 'bottom-left', 'left', 'top-left'],
            default: 'center',
            toClass: (value) => value ? `origin-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^origin-(.+)$/);
                return match ? match[1] : null;
            }
        },
        transformStyle: {
            label: 'Style',
            type: 'select',
            options: ['flat', 'preserve-3d'],
            default: 'flat',
            toClass: (value) => value ? `transform-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^transform-(flat|preserve-3d)$/);
                return match ? match[1] : null;
            }
        },
        translate: {
            label: 'Translate',
            type: 'select',
            options: ['0', 'px', '0.5', '1', '1.5', '2', '2.5', '3', '3.5', '4', '5', '6', '7', '8'],
            default: '0',
            toClass: (value) => value ? `translate-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^translate-(.+)$/);
                return match ? match[1] : null;
            }
        }
    }
};
